import { noop } from "@common/helpers/function";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { FilterTabPanel } from "@components/pageHeader/filters/FilterTabPanel";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import statusStyles from "@components/pageHeader/filters/Tabs/TransactionStatusFilter/TransactionStatusFilter.module.scss";
import type { PreviewOriginEntity } from "./cells/ApplyCoaPreviewNameCell";
import { ApplyCoaPreviewOriginSource } from "./applyCoaTemplatePreviewStatus";
import styles from "./ApplyCoaPreviewFilters.module.scss";

const PREVIEW_ORIGIN_SOURCES: string[] = Object.values(
    ApplyCoaPreviewOriginSource,
);

function isPreviewOriginSource(
    value: FilterMultiselectValue,
): value is ApplyCoaPreviewOriginSource {
    return typeof value === "string" && PREVIEW_ORIGIN_SOURCES.includes(value);
}

function buildOriginOptions(
    originEntity: PreviewOriginEntity | undefined,
): FilterMultiselectOption[] {
    return [
        {
            value: ApplyCoaPreviewOriginSource.template,
            label: "Template",
            searchableLabel: "Template",
        },
        {
            value: ApplyCoaPreviewOriginSource.entity,
            label: originEntity ? (
                <span className={styles.entityOption}>
                    <EntityAvatar size="xs" entity={originEntity} aria-hidden />
                    <span className={styles.entityName}>
                        {originEntity.name}
                    </span>
                </span>
            ) : (
                "Entity"
            ),
            searchableLabel: originEntity?.name ?? "Entity",
        },
    ];
}

export const ApplyCoaPreviewOriginFilterPanel = ({
    tabKey,
    originSources,
    originEntity,
    onOriginSourcesChange,
}: {
    tabKey: string;
    originSources: ApplyCoaPreviewOriginSource[];
    originEntity?: PreviewOriginEntity;
    onOriginSourcesChange: (sources: ApplyCoaPreviewOriginSource[]) => void;
}) => (
    <FilterTabPanel eventKey={tabKey}>
        <div className={statusStyles.filter}>
            <FilterMultiselect
                inDropdown={false}
                options={buildOriginOptions(originEntity)}
                value={originSources}
                onChange={(values) =>
                    onOriginSourcesChange(values.filter(isPreviewOriginSource))
                }
                name="Origin"
                onBlur={noop}
            />
        </div>
    </FilterTabPanel>
);
